export default __webpack_public_path__ + "static/media/cart_empty.f9648f62.svg";